import { Navigate } from "react-router-dom";
import { useAuth } from "./ProtectedRoutes";
import Loader from "../../containers/Loader/Loader";

export default function AdminOnly({ children }) {
    const { access } = useAuth();
    if(!access) return <Loader/>;
    if(access !== "admin") return <Navigate to="/login-page" replace />;
    return children;
}
